import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {Order, Product, StandardName} from "../../../../store/state/order.state";
import {ChangeSet} from "../../history/order-history.model";
import {CLIENT_COUNTRY_CONFIGS} from "../../../../configuration/configs/client-country-configs";
import {ClientCountryBasedConfig} from "../../../../configuration/configuration.model";

@Component({
    selector: 'product-details',
    templateUrl: './product-details.template.html',
    styleUrls: ['./product-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductDetailsComponent implements OnInit {

	@Input() order: Order;
	@Input() product: Product;
	@Input() changeSet: ChangeSet;
	@Input() translateClientsData: boolean;
	@Input() showCertificateQuestion: boolean = true;
	@Input() showPriceFactorTooltips: boolean = false;
	@Input() useOriginalTranslations: boolean;

	config: ClientCountryBasedConfig;


	ngOnInit(): void {
		this.config = CLIENT_COUNTRY_CONFIGS[this.order.clientCountry];
	}

	isIso27701(): boolean {
		return this.product.standard.name == StandardName.ISO_27701;
	}
}
